export class RegisterInput {
  country!: string;
  firstName!: string;
  middleName?: string;
  lastName!: string;
  phoneNumber!: string;
  email!: string;
  password!: string;

}
